import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const BreadcrumbContext = React.createContext(null);

const useProvideBreadcrumbs = () => {
    const navigate = useNavigate();
    const { state } = useLocation();

    const addBreadcrumb = (item, choice = {}, extra = []) => {
        navigate(item.href, {
            state: state
                ? {
                      ...state,
                      breadcrumbs: state?.breadcrumbs
                          ? [...state.breadcrumbs, ...extra, item]
                          : [extra, item],
                      ...choice
                  }
                : {
                      breadcrumbs: [extra, item],
                      ...choice
                  }
        });
    };

    const returnToBreadcrumb = (index) => {
        if (index - state.breadcrumbs.length + 1 < 0) {
            navigate(
                index -
                    state.breadcrumbs.length +
                    1 +
                    state.breadcrumbs.filter(
                        (item, cindex) => item.disabled && index < cindex
                    ).length
            );
        }
    };

    const replaceBreadcrumb = (item, repl, choice = {}) => {
        let oldCrumbs = [...state.breadcrumbs];
        oldCrumbs[oldCrumbs.length - 1] = repl;

        navigate(item.href, {
            state: {
                ...state,
                breadcrumbs: oldCrumbs ? [...oldCrumbs, item] : [item],
                ...choice
            }
        });
    };

    return {
        addBreadcrumb,
        returnToBreadcrumb,
        replaceBreadcrumb
    };
};

export const ProvideBreadcrumbs = ({ children }) => {
    const answers = useProvideBreadcrumbs();
    return (
        <BreadcrumbContext.Provider value={answers}>
            {children}
        </BreadcrumbContext.Provider>
    );
};

export const useBreadcrumbs = () => useContext(BreadcrumbContext);
